import React, { useState, useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import axiosHttp from "../config/axios.interceptor";
import Loader from "../components/Loader";
import { AuthContext } from "../contexts/AuthContext";
import { errorResponseMessage } from "./const.prop";

const AddBankAccount = ({ data }) => {
  const [info, setInfo] = useState({
    account_holder_name: data?.account_holder_name || "",
    account_number: data?.account_number || "",
    ifsc_code: data?.ifsc_code || "",
  });
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInfo({ ...info, [name]: value });
  };

  const formValidation = () => {
    let isValid = true;
    if (info.account_holder_name.trim().length < 3) {
      isValid = false;
      setError({ ...error, account_holder_name: "Enter minimum 3 characters" });
    }
    if (info.account_number === "") {
      isValid = false;
      setError({ ...error, account_number: "Account number required" });
    }
    if (info.ifsc_code === "") {
      isValid = false;
      setError({ ...error, ifsc_code: "IFSC required" });
    }
    if (isValid) {
      handleSubmit();
    } else {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: "Please fill the required fields",
      });
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const addBankDetails = await axiosHttp.post("stripe/bank-account", info);
      if (addBankDetails.status === 201) {
        appContext.updateModalState();
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <div className="modal-body">
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <input
                  className="form-control py-4"
                  type="text"
                  name="account_holder_name"
                  value={info?.account_holder_name || ""}
                  onChange={(e) => handleChange(e)}
                />
                <span>Account Holder Name</span>
              </label>
            </div>
            {error?.account_holder_name && (
              <p className="field-error">{error?.account_holder_name}</p>
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <input
                  className="form-control py-4"
                  type="number"
                  name="account_number"
                  value={info?.account_number || ""}
                  onChange={(e) => handleChange(e)}
                />
                <span>Account Number</span>
              </label>
            </div>
            {error?.account_number && (
              <p className="field-error">{error?.account_number}</p>
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <input
                  className="form-control py-4"
                  type="text"
                  name="ifsc_code"
                  value={info?.ifsc_code || ""}
                  onChange={(e) => handleChange(e)}
                />
                <span>IFSC Code</span>
              </label>
            </div>
            {error?.ifsc_code && (
              <p className="field-error">{error?.ifsc_code}</p>
            )}
          </div>
        </div>
      </div>
      <div className="modal-footer mt-2 mb-3">
        <button
          type="button"
          className="btn btn-outline-primary prime-btn"
          data-dismiss="modal"
          onClick={appContext.updateModalState}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-outline-primary modal-btn"
          onClick={formValidation}
        >
          Save
        </button>
      </div>
    </>
  );
};

export default AddBankAccount;
